module.exports = __webpack_public_path__ + "img/CONNECT2.1cb59c9f.svg";